import { Heading, UnorderedList, ListItem } from '@dapperlabs/core-fe';
import React from 'react';

import { RarityCard } from '../Cards';
import { SectionProps } from '../models';
import SectionContainer from '../SectionContainer';

export const AboutMomentRarity: React.FC<SectionProps> = ({
  cards,
  sectionHeading,
}) => {
  return (
    <SectionContainer>
      <>
        <Heading fontFamily='heading' textAlign='center'>
          {sectionHeading}
        </Heading>
        <UnorderedList
          justifyContent='space-between'
          gap='1rem'
          display='flex'
          overflowX={['scroll', 'scroll', 'scroll', 'hidden']}
          m={0}
          pt={['0.5rem', '3rem']}
          listStyleType='none'
        >
          {cards.map(({ fields }) => (
            <ListItem
              key={fields.cardHeading}
              border='1px solid'
              borderColor='gray.600'
              borderRadius='16px'
              boxShadow='1px 3px 19px #2B2C33'
            >
              <RarityCard
                cardHeading={fields.cardHeading}
                cardImgSrc={fields.cardImage.fields.file.url}
                cardText={fields.cardText}
                textGradientColor={fields.textGradientColor}
              />
            </ListItem>
          ))}
        </UnorderedList>
      </>
    </SectionContainer>
  );
};
